<template>
  <AuthLayout ref="authLayout" :modal-mode="modalMode" @close="$emit('close')">
    <template #hint>
      <div class="login-hint" @click="onGoLogin">已经有账号，去登录</div>
    </template>

    <!-- Tab -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'personal' }" @click="activeTab = 'personal'">
        <span class="tab-text">个人注册</span>
        <div class="tab-underline" v-if="activeTab === 'personal'"></div>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'company' }" @click="activeTab = 'company'">
        <span class="tab-text">企业注册</span>
        <div class="tab-underline" v-if="activeTab === 'company'"></div>
      </div>
    </div>

    <!-- 注册成功状态 -->
    <div class="form-body success-body" v-if="registerSuccess">
      <div class="success-icon">
        <svg viewBox="0 0 100 100" width="80" height="80">
          <circle cx="50" cy="50" r="44" fill="none" stroke="#7dcfa0" stroke-width="8"/>
          <polyline points="28,52 43,67 72,36" fill="none" stroke="#7dcfa0" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="success-title">恭喜您，注册成功</div>
      <div class="success-sub">{{ redirectCountdown }}S后自动跳转</div>
      <div class="login-btn profile-btn" @click="goProfile">
        {{ activeTab === 'personal' ? '完善个人资料' : '快去完善企业资料，发布资讯' }}
      </div>
    </div>

    <!-- 表单 -->
    <div class="form-body" v-else>
      <!-- 手机号 -->
      <div class="input-row">
        <div class="phone-icon"></div>
        <div class="divider-line"></div>
        <input class="input-field" type="text" v-model="form.mobile" placeholder="请输入注册手机号" maxlength="11" />
      </div>
      <div class="error-tip">{{ errors.mobile || '\u00a0' }}</div>

      <!-- 验证码 -->
      <div class="input-row">
        <img class="sms-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
        <input class="input-field" type="text" v-model="form.code" placeholder="请输入短信验证码" maxlength="6" />
        <div class="code-btn" @click="sendCode">{{ countdown > 0 ? countdown + 's后重发' : '获取验证码' }}</div>
      </div>
      <div class="error-tip">{{ errors.code || '\u00a0' }}</div>

      <!-- 登录密码 -->
      <div class="input-row">
        <img class="pwd-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
        <input class="input-field" type="password" v-model="form.password" placeholder="请输入新的登录密码" />
      </div>
      <div class="error-tip">{{ errors.password || '\u00a0' }}</div>

      <!-- 确认密码 -->
      <div class="input-row">
        <img class="pwd-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
        <input class="input-field" type="password" v-model="form.confirmPassword" placeholder="请再次输入登录密码" />
      </div>
      <div class="error-tip">{{ errors.confirmPassword || '\u00a0' }}</div>

      <!-- 最后一个输入框：个人=账号昵称，企业=企业名称 -->
      <div class="input-row last-input">
        <input class="input-field" type="text" v-model="form.lastName"
          :placeholder="activeTab === 'personal' ? '账号昵称' : '企业名称'" />
      </div>
      <div class="error-tip">{{ errors.lastName || '\u00a0' }}</div>

      <!-- 同意协议 -->
      <div class="agree-row" @click="agreed = !agreed">
        <div class="agree-box" :class="{ checked: agreed }">
          <div class="agree-inner" v-if="agreed"></div>
        </div>
        <span class="agree-text">我同意《中国品牌》杂志社的相关规定</span>
      </div>

      <!-- 注册按钮 -->
      <div class="login-btn" @click="handleRegister">立即注册</div>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from './AuthLayout.vue'
import { memberRegister, companyRegister, memberGetMessage, companyGetMessage } from '../../api'

export default {
  name: 'Register',
  components: {
    AuthLayout
  },
  props: {
    modalMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'personal',
      agreed: true,
      countdown: 0,
      timer: null,
      registerSuccess: false,
      redirectCountdown: 5,
      redirectTimer: null,
      form: {
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
        lastName: ''
      },
      errors: {
        mobile: '', code: '', password: '', confirmPassword: '', lastName: ''
      }
    }
  },
  methods: {
    // 发送短信验证码
    async sendCode() {
      if (this.countdown > 0) return
      if (!this.form.mobile || !/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.errors.mobile = '请输入正确的手机号'
        return
      }
      this.errors.mobile = ''
      try {
        const api = this.activeTab === 'personal' ? memberGetMessage : companyGetMessage
        await api({ areaCode: '86', mobile: this.form.mobile })
        this.countdown = 60
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) clearInterval(this.timer)
        }, 1000)
      } catch (e) {
        console.error('验证码发送失败', e)
        this.$refs.authLayout.showToast(this.getErrorMsg(e, '验证码发送失败，请稍后重试'), 'error')
      }
    },
    // 提交注册
    async handleRegister() {
      this.errors = { mobile: '', code: '', password: '', confirmPassword: '', lastName: '' }
      if (!this.form.mobile) { this.errors.mobile = '请输入手机号'; return }
      if (!this.form.code) { this.errors.code = '请输入验证码'; return }
      if (!this.form.password) { this.errors.password = '请输入登录密码'; return }
      if (!this.form.confirmPassword) { this.errors.confirmPassword = '请再次输入密码'; return }
      if (this.form.password !== this.form.confirmPassword) { this.errors.confirmPassword = '两次密码输入不一致'; return }
      if (!this.form.lastName) {
        this.errors.lastName = this.activeTab === 'personal' ? '请输入账号昵称' : '请输入企业名称'
        return
      }
      try {
        let res
        if (this.activeTab === 'personal') {
          res = await memberRegister({
            mobile: this.form.mobile,
            code: this.form.code,
            password: this.form.password,
            nickname: this.form.lastName
          })
        } else {
          res = await companyRegister({
            companyName: this.form.lastName,
            loginName: this.form.mobile,
            password: this.form.password,
            code: this.form.code
          })
        }
        const data = (res && res.data) || {}
        if (data.token) {
          localStorage.setItem('token', data.token)
        }
        localStorage.setItem('userType', this.activeTab)
        if (data.userInfo) {
          localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
        }
        this.registerSuccess = true
        this.redirectCountdown = 5
        const targetPath = this.activeTab === 'personal' ? '/user-center' : '/company-center'
        this.redirectTimer = setInterval(() => {
          this.redirectCountdown--
          if (this.redirectCountdown <= 0) {
            clearInterval(this.redirectTimer)
            this.$router.push(targetPath)
          }
        }, 1000)
      } catch (e) {
        console.error('注册失败', e)
        this.$refs.authLayout.showToast(this.getErrorMsg(e, '注册失败，请稍后重试'), 'error')
      }
    },
    goProfile() {
      clearInterval(this.redirectTimer)
      if (this.modalMode) {
        this.$emit('register-success')
      } else {
        if (this.activeTab === 'personal') {
          this.$router.push('/user-center')
        } else {
          this.$router.push('/company-center')
        }
      }
    },
    onGoLogin() {
      if (this.modalMode) {
        this.$emit('switch-login')
      } else {
        this.$router.push('/login')
      }
    },
    // 提取接口错误信息
    getErrorMsg(e, defaultMsg) {
      if (!e) return defaultMsg
      if (e.response && e.response.data) {
        const data = e.response.data
        if (typeof data === 'string') return data
        return data.msg || data.message || defaultMsg
      }
      return e.message || defaultMsg
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    if (this.redirectTimer) clearInterval(this.redirectTimer)
  }
}
</script>

<style scoped>
/* 顶部提示 */
.login-hint {
  width: 577px;
  text-align: right;
  margin-top: 21px;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer;
  position: relative;
  z-index: 3;
}
.login-hint:hover { color: rgba(160, 0, 0, 1); }

/* Tab */
.tab-bar {
  display: flex;
  width: 100%;
}
.tab-item {
  flex: 1;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(240, 245, 252, 1);
  border: 1px solid rgba(220, 230, 242, 1);
  border-bottom: none;
  position: relative;
}
.tab-item.active {
  background: rgba(255, 255, 255, 1);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-color: transparent;
  margin-top: -10px;
  height: 90px;
  z-index: 2;
}
.tab-text {
  font-size: 20px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  white-space: nowrap;
}
.tab-item.active .tab-text { color: rgba(228, 2, 16, 1); }
.tab-underline {
  width: 32px;
  height: 3px;
  background: rgba(228, 2, 16, 1);
  border-radius: 2px;
  margin-top: 6px;
}

/* 表单主体 */
.form-body {
  padding: 0 60px 40px;
  background: rgba(255, 255, 255, 1);
}

/* 输入框行 */
.input-row {
  display: flex;
  align-items: center;
  background: rgba(245, 250, 255, 1);
  border: 1px solid rgba(228, 242, 255, 1);
  border-radius: 24px;
  height: 50px;
  padding: 0 6px 0 18px;
  margin-top: 20px;
}
.last-input { padding: 0 18px; }
.phone-icon {
  width: 14px; height: 21px; flex-shrink: 0;
  background: url('./login-img/FigmaDDSSlicePNG1665c2a5d0482cc85b2c49298ea04615.png') center/contain no-repeat;
}
.sms-icon { width: 18px; height: 18px; flex-shrink: 0; }
.pwd-icon { width: 14px; height: 18px; flex-shrink: 0; }
.divider-line {
  width: 1px; height: 20px; flex-shrink: 0;
  background: rgba(200, 210, 220, 1);
  margin: 0 10px;
}
.input-field {
  flex: 1; min-width: 0; border: none; outline: none;
  background: transparent; font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  color: rgba(51, 51, 51, 1);
  margin-left: 8px;
}
.input-field::placeholder { color: rgba(178, 178, 178, 1); }

/* 获取验证码按钮 */
.code-btn {
  flex-shrink: 0;
  height: 36px;
  padding: 0 14px;
  background: rgba(160, 0, 0, 1);
  border-radius: 18px;
  color: #fff;
  font-size: 13px;
  font-family: Microsoft YaHei, sans-serif;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 8px;
}
.code-btn:hover { background: rgba(130, 0, 0, 1); }

/* 错误提示 */
.error-tip {
  height: 24px; line-height: 24px;
  font-size: 13px; color: rgba(249, 130, 136, 1);
  padding-left: 18px; margin-top: 2px;
}

/* 同意协议 */
.agree-row {
  display: flex; align-items: center;
  margin-top: 16px; cursor: pointer;
}
.agree-box {
  width: 14px; height: 14px; flex-shrink: 0;
  border: 1px solid rgba(228, 2, 16, 1);
  position: relative;
}
.agree-box.checked { background: rgba(228, 2, 16, 1); }
.agree-inner {
  width: 8px; height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  position: absolute; top: 2px; left: 1px;
}
.agree-text {
  font-size: 14px; color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-left: 8px;
}

/* 注册按钮 */
.login-btn {
  width: 100%; height: 52px;
  background: rgba(160, 0, 0, 1);
  border-radius: 26px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 18px; letter-spacing: 2px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer; margin-top: 16px;
  transition: background 0.2s;
}
.login-btn:hover { background: rgba(130, 0, 0, 1); }

/* 注册成功 */
.success-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 60px 50px;
}
.success-icon { margin-bottom: 20px; }
.success-title {
  font-size: 22px;
  color: rgba(228, 2, 16, 1);
  font-family: Microsoft YaHei, sans-serif;
  font-weight: bold;
  margin-bottom: 12px;
}
.success-sub {
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-bottom: 40px;
}
.profile-btn {
  margin-top: 0;
  width: 100%;
}
</style>
